export interface FAQItem {
  question: string;
  answer: string;
}

export interface ThemeItem {
  name: string;
  icon: string;
}

export interface ProductItem {
  title: string;
  icon: string;
  description: string;
  items: string[];
}

export const aboutFaqs: FAQItem[] = [
  {
    question: "What is Gracie & Lily Adventures?",
    answer: "Gracie & Lily Adventures is a children's book and gift brand inspired by real-life Bichon Frise sisters Gracie and Lily. It creates illustrated adventures, personalized children's books, digital stories and related gifts.",
  },
  {
    question: "Are Gracie and Lily real dogs?",
    answer: "Yes. Gracie and Lily are real-life Bichon Frise sisters and are the inspiration behind the stories and characters.",
  },
  {
    question: "What ages are Gracie & Lily books for?",
    answer: "The main audience is children approximately 3-8 years old.",
  },
  {
    question: "Are personalized children's books available?",
    answer: "Yes. Selected books can be personalized so the child becomes part of a Gracie and Lily adventure.",
  },
  {
    question: "What can be personalized?",
    answer: "Personalization varies by product and may include the child's name, appearance, special location and other story details.",
  },
  {
    question: "Are digital books available?",
    answer: "Yes. Digital Gracie & Lily adventures and book collections are available.",
  },
  {
    question: "Are printed books available?",
    answer: "Yes. Printed children's books and personalized printed books are available.",
  },
  {
    question: "Are the books suitable as gifts?",
    answer: "Yes. Gracie & Lily books are suitable for birthdays, Christmas, Easter, family celebrations and personalized keepsake gifts.",
  },
  {
    question: "What values do the stories teach?",
    answer: "Stories regularly include themes of kindness, friendship, courage, confidence, empathy, imagination, curiosity and helping others.",
  },
  {
    question: "How can I contact Gracie & Lily Adventures?",
    answer: "Email hello@gracieandlily.com.",
  },
];

export const aboutThemes: ThemeItem[] = [
  { name: "Kindness", icon: "fa-heart" },
  { name: "Friendship", icon: "fa-hand-holding-heart" },
  { name: "Courage", icon: "fa-shield-heart" },
  { name: "Confidence", icon: "fa-star" },
  { name: "Empathy", icon: "fa-face-smile" },
  { name: "Curiosity", icon: "fa-lightbulb" },
  { name: "Imagination", icon: "fa-wand-magic-sparkles" },
  { name: "Teamwork", icon: "fa-people-group" },
  { name: "Belonging", icon: "fa-house-heart" },
  { name: "Helping Others", icon: "fa-handshake-angle" },
  { name: "Family Connection", icon: "fa-house-chimney" },
  { name: "Exploration", icon: "fa-compass" },
  { name: "Discovery", icon: "fa-magnifying-glass" },
];

export const aboutProducts: ProductItem[] = [
  {
    title: "Adventure Books",
    icon: "fa-book-open",
    description: "Beautifully illustrated printed storybooks that take young readers on magical journeys.",
    items: ["Children's adventure books", "Printed books", "Bedtime stories"],
  },
  {
    title: "Personalized Books",
    icon: "fa-user-pen",
    description: "Let your child become the star of their very own Gracie and Lily adventure.",
    items: ["Personalized storybooks", "Deluxe personalized books"],
  },
  {
    title: "Digital Books",
    icon: "fa-tablet-screen-button",
    description: "Instant access to interactive digital adventures and curated collections.",
    items: ["Digital children's books", "Book bundles"],
  },
  {
    title: "Seasonal Stories",
    icon: "fa-snowflake",
    description: "Celebrate every holiday with heartwarming themed adventures.",
    items: ["Holiday books", "Christmas books", "Easter books", "Thanksgiving books"],
  },
  {
    title: "Gifts & Keepsakes",
    icon: "fa-gift",
    description: "Meaningful personalized gifts and keepsakes families will treasure forever.",
    items: ["Personalized gifts", "Keepsake gifts"],
  },
  {
    title: "Merchandise",
    icon: "fa-shirt",
    description: "Adorable Gracie & Lily goodies featuring your favorite Bichon sisters.",
    items: ["Gracie & Lily merchandise"],
  },
];

export const aboutAudience: string[] = [
  "Children ages 3-8",
  "Parents",
  "Grandparents",
  "Families",
  "Gift buyers",
  "Dog lovers",
  "Bichon Frise enthusiasts",
  "Personalized gift seekers",
  "Birthday & holiday shoppers",
];

export const aboutIdealUses: string[] = [
  "Bedtime reading",
  "Parent-child reading",
  "Grandparent-child reading",
  "Birthday gifts",
  "Christmas gifts",
  "Easter gifts",
  "Holiday gifts",
  "Personalized gifts",
  "Children's keepsakes",
  "Family reading traditions",
];